"use client";
import { AlertTriangle, CornerUpLeft } from "lucide-react";

export default function ErrorAgentNotFound({
  onReturn,
  message = "No se encontró el tipo de agente solicitado.",
}: {
  onReturn?: () => void;
  message?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[320px] bg-gradient-to-br from-gray-50 via-white to-gray-100 rounded-2xl shadow-lg border border-gray-200 p-10 text-center">
      {/* Icono de advertencia */}
      <div className="flex items-center justify-center w-20 h-20 bg-red-50 rounded-full mb-5 shadow-inner">
        <AlertTriangle className="w-10 h-10 text-red-600" strokeWidth={1.5} />
      </div>

      {/* Título */}
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">
        Tipo de agente no encontrado
      </h2>

      {/* Mensaje */}
      <p className="text-gray-600 mb-8 max-w-md leading-relaxed">
        {message} Por favor, verifica los parámetros de configuración o regresa a la página principal.
      </p>

      {/* Botón corporativo */}
      {onReturn && (
        <button
          onClick={onReturn}
          className="flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white rounded-xl font-medium shadow-md hover:bg-blue-700 hover:shadow-lg transition-all duration-200"
        >
          <CornerUpLeft className="w-4 h-4" />
          Retornar
        </button>
      )}
    </div>
  );
}
